import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84aa1b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-span-2 p-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "font-semibold text-gray-500 leading-tight uppercase mb-3" }
const _hoisted_4 = { class: "text-4xl" }
const _hoisted_5 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 64 64"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M57.939 6.061C53.184 1.306 45.702.673 40.526 4.445l-1.253-1.253l-1.38 1.379l-.929.929L35.8 6.665l1.222 1.221c-2.019 2.671-2.787 6.019-2.361 9.298l-.604 1.267l-2.578 3.189l-25.31 31.291l-.833.833l1.299 1.299L2 60.956L3.044 62l5.896-4.635l1.298 1.298l.832-.832l31.29-25.31l3.188-2.576l1.27-.604c3.278.424 6.625-.343 9.295-2.36l1.223 1.223l1.165-1.165l.93-.93l1.379-1.379l-1.254-1.254c3.771-5.177 3.137-12.661-1.617-17.415m-46.501 49.46a.244.244 0 0 1-.348 0L8.478 52.91a.245.245 0 1 1 .347-.347l2.613 2.611a.246.246 0 0 1 0 .347m2.782-3.237a1.771 1.771 0 0 1-2.504 0a1.75 1.75 0 0 1-.459-.82l3.422-.002a1.755 1.755 0 0 1-.459.822m-2.962-1.681c.075-.3.225-.585.458-.82a1.77 1.77 0 0 1 2.504 0c.234.235.384.521.459.822l-3.421-.002m5.472-2.347a.696.696 0 1 1-.983-.986a.696.696 0 0 1 .983.986m8.272-5.78l-3.478-3.479l7.12-7.119l3.479 3.479l-7.121 7.119m8.459-10.165a1.769 1.769 0 0 1-1.77-1.771c0-.332.097-.641.257-.906l2.418 2.42a1.73 1.73 0 0 1-.905.257m1.514-.866l-2.419-2.419c.266-.159.572-.256.904-.256a1.77 1.77 0 0 1 1.771 1.77c0 .332-.097.64-.256.905m7.456-.243l-9.633-9.632l1.337-1.652l9.947 9.95l-1.651 1.334m5.691-3.717l-11.611-11.61c-.085-2.234.479-4.451 1.728-6.323l16.209 16.209c-1.873 1.25-4.091 1.809-6.326 1.724m8.989-1.837L38.354 6.89l.929-.929l18.758 18.758l-.93.929m1.038-3.58L41.933 5.852c4.393-2.98 10.633-2.385 14.617 1.599c3.983 3.983 4.579 10.225 1.599 14.617M56.7 37.766c-.64-3.503-3.933-4.175-3.933-4.175L46.602 44.98c-.184-1.319-1.221-2.711-2.817-3.576c-2.291-1.241-4.868-.918-5.753.718c-.886 1.637.253 3.968 2.545 5.21c2.293 1.239 4.868.918 5.753-.719l4.92-9.088c.521-.008 1.297.303 2.363 1.524c2.233 2.56 5.265 2.849 5.265 2.849s-1.623-1.088-2.178-4.132"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12.955 28.799c3.805.306 7.065-1.651 7.283-4.369l1.207-15.091c.691-.319 1.915-.363 4.069.645c4.507 2.103 8.74.699 8.74.699s-2.821-.499-5.366-4.247c-2.931-4.319-7.742-3.27-7.742-3.27l-1.514 18.916c-1.027-1.661-3.24-2.913-5.892-3.125c-3.804-.304-7.064 1.653-7.281 4.372c-.217 2.717 2.689 5.167 6.496 5.47m12.113 11.872l-1.735-1.735l.348-.348l1.735 1.735zm.642-.645l-1.736-1.736l.348-.348l1.735 1.736zm.643-.642l-1.737-1.736l.348-.348l1.737 1.737zm.994-.992l-.346.348l-1.74-1.735l.347-.347z"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m22.6 38.897l2.503 2.502l5.945-5.944l-2.503-2.503l-5.945 5.945m2.503 2.155l-2.154-2.154l2.625-2.625l2.153 2.154l-2.624 2.625"
}, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "text-xl font-bold text-gray-500 pr-2" }
const _hoisted_11 = {
  key: 0,
  class: ""
}
const _hoisted_12 = {
  key: 1,
  class: ""
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  name: "plan",
  id: "plan-growth",
  value: "growth",
  class: "absolute h-0 w-0 appearance-none",
  checked: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute top-4 right-4 h-6 w-6 inline-flex items-center justify-center rounded-full bg-green-200" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    class: "h-5 w-5 text-green-600"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    })
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      spaceBetween: 2,
      class: "p-2",
      slidesPerView: 5,
      breakpoints: _ctx.breakpoints,
      onSlideChange: _ctx.onChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, j) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: item.id
          }, {
            default: _withCtx(() => [
              (item.title)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["relative flex flex-col bg-white p-5 rounded-lg shadow-md cursor-pointer", {'locked': j >= 4}]),
                    onClick: ()=> _ctx.goToLyric(item, j),
                    style: {"min-height":"15vh"}
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold text-gray-900", {'text-2xl p-2': item.key == 'karaoke'}])
                    }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.level), 1),
                      _createElementVNode("small", null, _toDisplayString(item.levelextra), 1),
                      (item.key == 'karaoke')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_9))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("span", null, [
                      (item.key !== 'karaoke')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.totalKanji), 1),
                            (item.key == 'veryeasy')
                              ? (_openBlock(), _createElementBlock("small", _hoisted_11, "仮名"))
                              : (_openBlock(), _createElementBlock("small", _hoisted_12, "漢字"))
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_13,
                    _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: _normalizeClass(["absolute inset-0 border-2 border-green-500 bg-green-200 bg-opacity-10 rounded-lg", {'hidden': !item.isSelected}])
                    }, _hoisted_15, 2)
                  ], 10, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["breakpoints", "onSlideChange"])
  ]))
}